import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { SnowflakeAiAccesses } from "./accesses.ts";
import { SnowflakeAiComponents } from "./components.ts";
import { SnowflakeAiIconUrl } from "./icon.ts";

// Rule filter values compile to regular expressions. Every request carries
// every filter, empty where its access type has none, so a rule never
// matches by omission. `grant.entry` is the whole `PRIVILEGE:OBJECT` entry.
const SnowflakeAiFilters = {
  account: { keys: ["id"] },
  warehouse: { keys: ["name"] },
  role: { keys: ["name"] },
  object: { keys: ["name"] },
  privilege: { keys: ["name"] },
  grant: { keys: ["entry"] },
} as const satisfies AnyFilterSchema;
export type SnowflakeAiFilters = typeof SnowflakeAiFilters;

export const SnowflakeAiRegistration = Registration({
  accesses: SnowflakeAiAccesses,
  category: "resource",
  components: SnowflakeAiComponents,
  docs: {},
  filters: SnowflakeAiFilters,
  itemKind: "Account",
  label: "Snowflake (AI)",
  logoUrl: SnowflakeAiIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("snowflake-ai", SnowflakeAiRegistration);
